export enum ActionTypes {
  REQUEST = "@sistema-avaliacao/REQUEST",
  SUCCESS = "@sistema-avaliacao/SUCCESS",
  FAILURE = "@sistema-avaliacao/FAILURE",
}
